(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["group-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 获取所有导航项和目标元素
    const allNavItems = document.querySelectorAll('.nav-item');
    const navItems = Array.from(allNavItems).filter(item => {
      return window.getComputedStyle(item).display !== 'none';
    });

    const targetElements = new Map();
    
    // 创建目标元素映射
    navItems.forEach(item => {
      const targetId = item.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElements.set(targetId, targetElement);
      }
    });

    // 点击导航项事件
    navItems.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        
        // 移除所有激活状态
        navItems.forEach(nav => nav.classList.remove('active'));
        
        // 添加当前激活状态
        this.classList.add('active');
        
        // 获取目标ID并滚动到对应元素
        const targetId = this.getAttribute('data-target');
        const targetElement = targetElements.get(targetId);
        
        if (targetElement) {
          // 计算滚动位置（考虑固定导航栏高度）
          const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const navHeight = document.querySelector('.group-navigation').offsetHeight;
          
          // 平滑滚动到目标位置
          window.scrollTo({
            top: offsetTop - navHeight,
            behavior: 'smooth'
          });
        }
      });
    });

    // 监听滚动事件，根据滚动位置更新激活的导航项
    let ticking = false;
    
    function updateActiveNav() {
      const scrollPosition = window.scrollY + 300; // 添加偏移量以提前触发
      let activeTarget = null;
      let lastValidTarget =  null; // 用于存储找到的最后一个有效的、在视口上方的目标
      
      // 找到当前应该激活的目标
      for (let [targetId, element] of targetElements) {
        const offsetTop = element.offsetParent.offsetTop;
        const offsetBottom = offsetTop + element.offsetParent.offsetHeight;
        
        if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
          activeTarget = targetId;
          break;
        }
        // 如果当前元素的顶部低于滚动位置，说明滚动位置还在当前元素的上方区域
          // 记录这个元素作为潜在的激活目标（如果后续没有更匹配的）
          if (offsetTop < scrollPosition) {
              lastValidTarget = targetId;
          }
      }

      // 如果在任何元素范围内都没找到，则使用最后一个在视口上方的元素
      if (!activeTarget) {
          activeTarget = lastValidTarget;
      }
      if (!activeTarget) {
          activeTarget = navItems[0].getAttribute('data-target');
      }
      
      // 更新导航项的激活状态
      navItems.forEach(item => {
        const targetId = item.getAttribute('data-target');
        if (targetId === activeTarget) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
      
      ticking = false;
    }
    
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateActiveNav);
        ticking = true;
      }
    }
    
    // 监听滚动事件
    window.addEventListener('scroll', requestTick);
    
    // 初始化时更新一次激活状态
    updateActiveNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
